'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.cjs');
var index = require('../node_modules/prop-types/index.cjs');

var propTypesExports = /*@__PURE__*/ index.__require();
var PropTypes = /*@__PURE__*/_commonjsHelpers.getDefaultExportFromCjs(propTypesExports);

module.exports = PropTypes;
//# sourceMappingURL=index4.cjs.map
